import { render, staticRenderFns } from "./NewRegion.vue?vue&type=template&id=7b04a6b2&"
import script from "./NewRegion.vue?vue&type=script&lang=js&"
export * from "./NewRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports